import * as React from 'react'
import { getMerchantsTable } from '../../../Model/MerchantModel'
import HttpActionsService from '../../../Services/HttpActionsService'
import { inject, observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import LocalizationStore from '../../../Stores/LocalizationStore'
import UserStore from '../../../Stores/UserStore'
import ExportToCsvComponent from '../../../Components/ExportToCsvComponent'
import { ExportType } from '../../../Stores/ExportStore'
import PageSizeComponent from '../../../Components/PageSizeComponent'

export interface IMerchantsPageProps {
    httpActionsService?: HttpActionsService
    localizationStore?: LocalizationStore
    userStore?: UserStore
}

@inject('httpActionsService')
@inject('localizationStore')
@inject('userStore')
@observer
export default class MerchantsPage extends React.Component<IMerchantsPageProps> {

    componentDidMount() {
        this.props.httpActionsService!.getMerchants()
    }

    render() {
        const { localizationStore, userStore } = this.props
        return (
            <div className="merchantsPage row page">
                <div className="col-12">
                    <h4>{localizationStore!.t('MerchantsPageHeader')}</h4>
                </div>
                <div className="col-12">
                    <PageSizeComponent />
                    <ExportToCsvComponent exportType={ExportType.Merchants} />
                    {getMerchantsTable()}
                </div>
                <div className="col-12" hidden={!(userStore!.checkAdmin || userStore!.checkSuperAdmin)}>
                    <Link to="/merchant">
                        {`${localizationStore!.t('Create')} ${localizationStore!.t('Merchant')}`}
                    </Link>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Merchant/MerchantsPage.tsx